var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Profile_Icon",
    "data-name": "Profile Icon",
    d: "M21.661,23.848a19.156,19.156,0,0,0,7.72-1.575,20.492,20.492,0,0,0,6.382-4.334,20.38,20.38,0,0,0,4.323-6.372,19.242,19.242,0,0,0,1.565-7.73,19.156,19.156,0,0,0-1.575-7.72,20.618,20.618,0,0,0-4.334-6.392A20.118,20.118,0,0,0,29.36-14.6a19.374,19.374,0,0,0-7.72-1.554A19.3,19.3,0,0,0,13.93-14.6a20.272,20.272,0,0,0-6.382,4.323A20.384,20.384,0,0,0,3.215-3.883,19.264,19.264,0,0,0,1.65,3.837a19.133,19.133,0,0,0,1.575,7.73A20.6,20.6,0,0,0,13.93,22.273,19.133,19.133,0,0,0,21.661,23.848Zm-.021-3.129a16.549,16.549,0,0,1-4.385-.6,17.7,17.7,0,0,1-4.128-1.709,14.921,14.921,0,0,1-3.448-2.7,9.884,9.884,0,0,1,2.892-2.851,14.208,14.208,0,0,1,4.117-1.812,18.855,18.855,0,0,1,4.951-.628,18.95,18.95,0,0,1,4.92.618,14.171,14.171,0,0,1,4.117,1.8,9.739,9.739,0,0,1,2.9,2.872,14.524,14.524,0,0,1-3.428,2.7,17.7,17.7,0,0,1-4.128,1.709A16.549,16.549,0,0,1,21.64,20.718Zm0-13.608a6.324,6.324,0,0,1-3.417-1A7.053,7.053,0,0,1,15.8,3.477a7.819,7.819,0,0,1-.9-3.778,7.461,7.461,0,0,1,.9-3.623,7.128,7.128,0,0,1,2.429-2.635,6.159,6.159,0,0,1,3.407-.988,6.109,6.109,0,0,1,3.4.988,7.243,7.243,0,0,1,2.429,2.635A7.394,7.394,0,0,1,28.372-.3a7.939,7.939,0,0,1-.9,3.8,7.012,7.012,0,0,1-2.419,2.656A6.065,6.065,0,0,1,21.64,7.111Z",
    transform: "translate(-1.65 16.152)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.58452602951f82fcc594534a5802f4c3.svg";
export { ForwardRef as ReactComponent };